/****************
 * LEARN: THE ARTICLES AND THEIR QUIZZES. 2026-10-22.
 * TWIN FILE: frontend/src/lib/learn.core.ts and mobile-app/src/lib/learn.core.ts
 * must stay byte-identical. GENERATED by the engagement session from the
 * reviewed content (scratchpad learn_content.json); the words are in
 * locales/<lang>/learn.json under art.<id>.* and quiz.<id>.*.
 *
 * Guillaume: "the learn section should also divide like the AI section ...
 * Videos, Articles and Quiz ... All the quiz responses must exist in the
 * articles so if someone took the time to read it all, he should be able to
 * easily answer every questions." Each question carries the paragraph that
 * answers it, shown after the answer, and a test checks it is in the article.
 * Written from the Orb's knowledge files (backend .../rest/knowledge), the
 * checked description of how CopyFi works.
 ****************/

export interface LearnArticle {
  id: string;
  /** How many paragraphs: art.<id>.p1 .. p<n>. */
  paragraphs: number;
  /** The knowledge files it was written from. */
  knowledge: string[];
}

export interface QuizQuestion {
  /** Index 0-3 of the right option: quiz.<article>.q<n>.o1..o4. */
  correct: number;
  /** The paragraph (1-based) of the article that answers it. */
  answeredIn: number;
}

export const LEARN_ARTICLES: LearnArticle[] = [
  {
    "id": "how-copyfi-works",
    "paragraphs": 7,
    "knowledge": [
      "01-the-platform.md",
      "02-choosing-a-trader.md",
      "06-when-something-looks-wrong.md",
      "08-new-to-this.md",
      "14-getting-started-and-your-progress.md"
    ]
  },
  {
    "id": "choosing-a-trader",
    "paragraphs": 6,
    "knowledge": [
      "02-choosing-a-trader.md",
      "14-getting-started-and-your-progress.md",
      "06-when-something-looks-wrong.md"
    ]
  },
  {
    "id": "your-strategy",
    "paragraphs": 7,
    "knowledge": [
      "03-strategy-builder.md",
      "14-getting-started-and-your-progress.md",
      "01-the-platform.md"
    ]
  },
  {
    "id": "leverage-and-risk",
    "paragraphs": 6,
    "knowledge": [
      "05-leverage-margin-liquidation.md",
      "03-strategy-builder.md"
    ]
  },
  {
    "id": "connecting-an-exchange",
    "paragraphs": 6,
    "knowledge": [
      "04-connecting-a-broker.md",
      "06-when-something-looks-wrong.md",
      "01-the-platform.md"
    ]
  },
  {
    "id": "when-something-looks-wrong",
    "paragraphs": 7,
    "knowledge": [
      "06-when-something-looks-wrong.md",
      "11-when-the-orb-reaches-out.md",
      "14-getting-started-and-your-progress.md",
      "02-choosing-a-trader.md"
    ]
  },
  {
    "id": "strategy-builder",
    "paragraphs": 7,
    "knowledge": [
      "03-strategy-builder.md"
    ]
  },
  {
    "id": "how-orders-are-adjusted",
    "paragraphs": 7,
    "knowledge": [
      "03-strategy-builder.md",
      "05-leverage-margin-liquidation.md",
      "06-when-something-looks-wrong.md"
    ]
  },
  {
    "id": "cross-vs-isolated",
    "paragraphs": 7,
    "knowledge": [
      "05-leverage-margin-liquidation.md",
      "03-strategy-builder.md"
    ]
  },
  {
    "id": "limit-vs-market",
    "paragraphs": 7,
    "knowledge": [
      "03-strategy-builder.md",
      "06-when-something-looks-wrong.md"
    ]
  },
  {
    "id": "reading-the-numbers",
    "paragraphs": 7,
    "knowledge": [
      "02-choosing-a-trader.md",
      "14-getting-started-and-your-progress.md"
    ]
  },
  {
    "id": "why-copies-get-skipped",
    "paragraphs": 7,
    "knowledge": [
      "03-strategy-builder.md",
      "06-when-something-looks-wrong.md",
      "05-leverage-margin-liquidation.md",
      "11-when-the-orb-reaches-out.md",
      "01-the-platform.md"
    ]
  },
  {
    "id": "stop-refused-by-exchange",
    "paragraphs": 6,
    "knowledge": [
      "05-leverage-margin-liquidation.md",
      "03-strategy-builder.md",
      "06-when-something-looks-wrong.md",
      "11-when-the-orb-reaches-out.md"
    ]
  },
  {
    "id": "kill-switch-too-tight",
    "paragraphs": 6,
    "knowledge": [
      "03-strategy-builder.md",
      "02-choosing-a-trader.md",
      "01-the-platform.md",
      "11-when-the-orb-reaches-out.md"
    ]
  }
];

export const QUIZZES: Record<string, QuizQuestion[]> = {
  "how-copyfi-works": [
    {
      "correct": 1,
      "answeredIn": 5
    },
    {
      "correct": 0,
      "answeredIn": 4
    },
    {
      "correct": 3,
      "answeredIn": 3
    },
    {
      "correct": 2,
      "answeredIn": 6
    },
    {
      "correct": 1,
      "answeredIn": 4
    }
  ],
  "choosing-a-trader": [
    {
      "correct": 0,
      "answeredIn": 1
    },
    {
      "correct": 3,
      "answeredIn": 2
    },
    {
      "correct": 2,
      "answeredIn": 3
    },
    {
      "correct": 1,
      "answeredIn": 6
    },
    {
      "correct": 0,
      "answeredIn": 5
    }
  ],
  "your-strategy": [
    {
      "correct": 3,
      "answeredIn": 1
    },
    {
      "correct": 2,
      "answeredIn": 2
    },
    {
      "correct": 1,
      "answeredIn": 3
    },
    {
      "correct": 0,
      "answeredIn": 6
    },
    {
      "correct": 3,
      "answeredIn": 5
    }
  ],
  "leverage-and-risk": [
    {
      "correct": 2,
      "answeredIn": 1
    },
    {
      "correct": 1,
      "answeredIn": 2
    },
    {
      "correct": 0,
      "answeredIn": 4
    },
    {
      "correct": 3,
      "answeredIn": 5
    },
    {
      "correct": 2,
      "answeredIn": 6
    }
  ],
  "connecting-an-exchange": [
    {
      "correct": 1,
      "answeredIn": 2
    },
    {
      "correct": 0,
      "answeredIn": 3
    },
    {
      "correct": 3,
      "answeredIn": 4
    },
    {
      "correct": 2,
      "answeredIn": 6
    },
    {
      "correct": 1,
      "answeredIn": 5
    }
  ],
  "when-something-looks-wrong": [
    {
      "correct": 0,
      "answeredIn": 1
    },
    {
      "correct": 3,
      "answeredIn": 2
    },
    {
      "correct": 2,
      "answeredIn": 5
    },
    {
      "correct": 1,
      "answeredIn": 6
    },
    {
      "correct": 0,
      "answeredIn": 7
    }
  ],
  "strategy-builder": [
    {
      "correct": 1,
      "answeredIn": 1
    },
    {
      "correct": 2,
      "answeredIn": 3
    },
    {
      "correct": 2,
      "answeredIn": 4
    },
    {
      "correct": 1,
      "answeredIn": 5
    },
    {
      "correct": 0,
      "answeredIn": 7
    }
  ],
  "how-orders-are-adjusted": [
    {
      "correct": 1,
      "answeredIn": 3
    },
    {
      "correct": 2,
      "answeredIn": 5
    },
    {
      "correct": 3,
      "answeredIn": 6
    },
    {
      "correct": 0,
      "answeredIn": 6
    },
    {
      "correct": 2,
      "answeredIn": 4
    }
  ],
  "cross-vs-isolated": [
    {
      "correct": 1,
      "answeredIn": 2
    },
    {
      "correct": 0,
      "answeredIn": 2
    },
    {
      "correct": 2,
      "answeredIn": 3
    },
    {
      "correct": 3,
      "answeredIn": 4
    },
    {
      "correct": 1,
      "answeredIn": 6
    }
  ],
  "limit-vs-market": [
    {
      "correct": 1,
      "answeredIn": 2
    },
    {
      "correct": 0,
      "answeredIn": 4
    },
    {
      "correct": 2,
      "answeredIn": 3
    },
    {
      "correct": 3,
      "answeredIn": 6
    },
    {
      "correct": 0,
      "answeredIn": 7
    }
  ],
  "reading-the-numbers": [
    {
      "correct": 1,
      "answeredIn": 3
    },
    {
      "correct": 0,
      "answeredIn": 4
    },
    {
      "correct": 2,
      "answeredIn": 5
    },
    {
      "correct": 1,
      "answeredIn": 6
    },
    {
      "correct": 3,
      "answeredIn": 2
    }
  ],
  "why-copies-get-skipped": [
    {
      "correct": 1,
      "answeredIn": 3
    },
    {
      "correct": 1,
      "answeredIn": 5
    },
    {
      "correct": 0,
      "answeredIn": 4
    }
  ],
  "stop-refused-by-exchange": [
    {
      "correct": 2,
      "answeredIn": 1
    },
    {
      "correct": 1,
      "answeredIn": 4
    },
    {
      "correct": 2,
      "answeredIn": 2
    }
  ],
  "kill-switch-too-tight": [
    {
      "correct": 1,
      "answeredIn": 1
    },
    {
      "correct": 2,
      "answeredIn": 4
    },
    {
      "correct": 3,
      "answeredIn": 6
    }
  ]
};

/** A quiz is passed perfectly when every answer is right. */
export function quizScore(answers: number[], quiz: QuizQuestion[]): number {
  return quiz.reduce((n, q, i) => n + (answers[i] === q.correct ? 1 : 0), 0);
}

/** The overall award: every quiz done without a mistake at least once. */
export function isExpert(perfectQuizzes: string[]): boolean {
  return LEARN_ARTICLES.every((a) => perfectQuizzes.includes(a.id));
}

/****************
 * ARTICLES BY SUBJECT, AND THE SHOW ME EACH ONE LEADS TO. 2026-10-24.
 *
 * Guillaume: "Every articles is listed twice, please list them once and divide
 * them by subject", and "Ask the Orb about this" should "automatically add a
 * 'Show me' and guide him with the most obvious path to do the job".
 * Labels: learn.json subject.<id>. Guides: orbGuides (find-a-trader...).
 ****************/
export const ARTICLE_SUBJECTS: { id: string; articles: string[] }[] = [
  { id: 'start', articles: ['how-copyfi-works', 'connecting-an-exchange'] },
  { id: 'traders', articles: ['choosing-a-trader', 'reading-the-numbers'] },
  { id: 'strategy', articles: ['your-strategy', 'strategy-builder', 'how-orders-are-adjusted', 'limit-vs-market'] },
  { id: 'risk', articles: ['leverage-and-risk', 'cross-vs-isolated'] },
  { id: 'help', articles: ['when-something-looks-wrong', 'why-copies-get-skipped', 'stop-refused-by-exchange', 'kill-switch-too-tight'] },
];

export const ARTICLE_GUIDE: Record<string, string> = {
  'how-copyfi-works': 'first-steps',
  'connecting-an-exchange': 'connect-exchange',
  'choosing-a-trader': 'find-a-trader',
  'reading-the-numbers': 'find-a-trader',
  'your-strategy': 'create-strategy',
  'strategy-builder': 'create-strategy',
  'how-orders-are-adjusted': 'create-strategy',
  'limit-vs-market': 'create-strategy',
  'leverage-and-risk': 'create-strategy',
  'cross-vs-isolated': 'create-strategy',
  'when-something-looks-wrong': 'adjust-rules',
  'why-copies-get-skipped': 'adjust-rules',
  'stop-refused-by-exchange': 'adjust-rules',
  'kill-switch-too-tight': 'adjust-rules',
};

/****************
 * ONE BADGE PER QUIZ. 2026-10-24.
 *
 * Guillaume: "each one different". Every quiz finished without a mistake earns
 * its own badge: its own icon (a Phosphor name, mapped in each app) and colour.
 ****************/
export const QUIZ_BADGES: Record<string, { icon: string; color: string }> = {
  'how-copyfi-works': { icon: 'Rocket', color: '#F59E0B' },
  'choosing-a-trader': { icon: 'UsersThree', color: '#22C55E' },
  'your-strategy': { icon: 'Strategy', color: '#3B82F6' },
  'leverage-and-risk': { icon: 'Lightning', color: '#EF4444' },
  'connecting-an-exchange': { icon: 'Key', color: '#A855F7' },
  'when-something-looks-wrong': { icon: 'WarningCircle', color: '#F97316' },
  'strategy-builder': { icon: 'SlidersHorizontal', color: '#06B6D4' },
  'how-orders-are-adjusted': { icon: 'Scales', color: '#EAB308' },
  'cross-vs-isolated': { icon: 'ShieldCheck', color: '#14B8A6' },
  'limit-vs-market': { icon: 'ArrowsDownUp', color: '#EC4899' },
  'reading-the-numbers': { icon: 'ChartLineUp', color: '#84CC16' },
};

/****************
 * QUIZZES ON THE LESSONS. 2026-10-25, Guillaume: "Add more Quizz". One quiz
 * per short lesson (lib/lessons.core.ts), three questions each, answered in the
 * lesson's own paragraphs (common.json lesson.<lesson>.p<n>). Texts:
 * learn.json quiz.<quiz id>.q<n>[.o1..o4].
 ****************/
export const LESSON_QUIZZES: Record<string, { lesson: string; questions: QuizQuestion[] }> = {
  'lesson-how-copy-works': { lesson: 'howCopyWorks', questions: [{ correct: 1, answeredIn: 1 }, { correct: 0, answeredIn: 2 }, { correct: 2, answeredIn: 3 }] },
  'lesson-one-win': { lesson: 'oneWin', questions: [{ correct: 1, answeredIn: 1 }, { correct: 2, answeredIn: 2 }, { correct: 0, answeredIn: 3 }] },
  'lesson-losses-are-part': { lesson: 'lossesArePart', questions: [{ correct: 1, answeredIn: 1 }, { correct: 0, answeredIn: 2 }, { correct: 2, answeredIn: 3 }] },
  'lesson-drawdowns': { lesson: 'drawdowns', questions: [{ correct: 1, answeredIn: 1 }, { correct: 3, answeredIn: 2 }, { correct: 0, answeredIn: 3 }] },
  'lesson-read-record': { lesson: 'readRecord', questions: [{ correct: 2, answeredIn: 2 }, { correct: 1, answeredIn: 2 }, { correct: 0, answeredIn: 3 }] },
  'lesson-spread-risk': { lesson: 'spreadRisk', questions: [{ correct: 0, answeredIn: 1 }, { correct: 1, answeredIn: 2 }, { correct: 2, answeredIn: 3 }] },
  'lesson-kill-switch': { lesson: 'killSwitch', questions: [{ correct: 1, answeredIn: 1 }, { correct: 0, answeredIn: 2 }, { correct: 2, answeredIn: 3 }] },
  'lesson-before-live': { lesson: 'beforeLive', questions: [{ correct: 1, answeredIn: 1 }, { correct: 0, answeredIn: 2 }, { correct: 2, answeredIn: 3 }] },
};

/** Every quiz, articles' and lessons'. */
export const ALL_QUIZZES: Record<string, QuizQuestion[]> = {
  ...QUIZZES,
  ...Object.fromEntries(Object.entries(LESSON_QUIZZES).map(([k, v]) => [k, v.questions])),
};
